import axios from "axios";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.css";

const Modal = require("../../../../libraries/Modal");

// require("../../../global/policy-modal");
require("../../../modules/existing-customer")(TomSelect);
require("../../../modules/customer-verification")(TomSelect, Modal, {
	hasDevice: false
});
require("../../../modules/new-customer")(TomSelect);

// require("./parts/customer-collapse");

require("./parts/sim-functions");
// require("./parts/my-plan-submit");

(function() {

	axios.get("/my-plan/plan-data")
	.then(res => {

		const { infoCard, hasAddons, addonSelection } = res.data;
		const addonsWrapper = document.getElementById("additional-services");

		document.getElementById("info-card")
			.innerHTML = infoCard;

		addonsWrapper.innerHTML = addonSelection;

		if ( ! hasAddons ) {
			addonsWrapper.classList.add("hidden");
		}

		document.getElementById("terms-wrapper").classList.remove("hidden");

		require("./parts/my-plan");
		require("../../../modules/leave-page-warning");
		require("./parts/addon-functions");
		require("./parts/my-plan-submit");
	})
	.catch(err => {
		console.log(err);
	});

	axios.get("/my-plan/subscription-data")
	.then(res => {

		const { subscriptionTabs } = res.data;

		document.getElementById("subscription-cnt")
				.innerHTML = subscriptionTabs;

		require("./parts/number-tab-actions");
		require("./parts/get-new-number-functions")(TomSelect);
		require("./parts/keep-same-number-functions")(TomSelect);
		require("../../../../libraries/collapse");
	})
	.catch(err => {
		console.log(err);
	})

	const policyModalElm = document.getElementById("policy-modal");
	new Modal({
		modal: policyModalElm,
		showBtns: document.getElementsByClassName("js-show-policy-btn")
	});
	
	axios.get("/mobile-documents")
		.then(res => {

			const { policyDescription, consentDescription } = res.data
			const consentCard = document.getElementById("consent-card");

			consentCard.classList.add("bg-white", "shadow-round");
			consentCard.innerHTML = consentDescription;

			document.getElementById("policy-docs")
				.innerHTML = policyDescription;
		})
		.catch(err => {
			console.log(err);
		})
})();